import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FileSpreadsheet, FileText, FileJson, Database } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const TYPE_CONFIG: Record<string, { icon: any; color: string; badge: string }> = {
    csv:     { icon: FileText,        color: 'emerald', badge: 'CSV'     },
    xlsx:    { icon: FileSpreadsheet, color: 'blue',    badge: 'Excel'   },
    xls:     { icon: FileSpreadsheet, color: 'blue',    badge: 'Excel'   },
    json:    { icon: FileJson,        color: 'amber',   badge: 'JSON'    },
    parquet: { icon: Database,        color: 'violet',  badge: 'Parquet' },
};

const FileSourceNode = ({ data, selected }: NodeProps) => {
    const ftype = (data.fileType || '').toLowerCase();
    const cfg = TYPE_CONFIG[ftype] || null;
    const Icon = cfg ? cfg.icon : FileText;
    const label = data.label || data.fileName || 'File Source';
    const cols = data.columns?.length ?? 0;
    const rows = data.rowCount ?? 0;

    const badgeText = cfg ? cfg.badge : 'File';
    const bgClass = cfg ? cfg.color : 'emerald';

    return (
        <BaseNodeUI
            title={label}
            icon={Icon}
            colorClass=""
            bgClass={bgClass}
            selected={selected}
            isSource={true}
            isTarget={false}
            isRunning={data?.executionStatus === 'Running'} 
            executionStatus={data?.executionStatus}
        >
            <div className="text-[10px] text-slate-500 font-medium tracking-tight">
                {badgeText} {rows > 0 ? `· ${rows.toLocaleString()} rows` : cols > 0 ? `· ${cols} cols` : ''}
            </div>
        </BaseNodeUI>
    );
};

export default memo(FileSourceNode);

